module.exports = __webpack_public_path__ + "assets/img/language.a84ceaa6.svg";